import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import accountThumbnail from "../../../../img/company.png";
import DashboardCompanyUpperLoader from "./loader";
import {
  FadeButton,
  InfoTableButton,
  SolidButton,
} from "../../../library/button";
import NumberFormat from "react-number-format";
import { MoonLoader } from "react-spinners";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { changeCompanyModal } from "../../../../redux/actions/company";
import "./style.scss";
import Text from "../../../library/text";

const Index = ({ activeDisplay, setActiveDisplay }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const companyDetails = useSelector((state) => state.company.details);
  const loading = useSelector((state) => state.company.fetchDetails.loading);

  const subscription = useSelector((state) => state.company.subscription?.main);

  const renderActiveBadge = () => {
    if (subscription?.active) {
      return <InfoTableButton color="green" title="Aktivt abonnement" />;
    } else {
      return <InfoTableButton color="red" title="Inaktivt abonnement" />;
    }
  };

  const renderCompanyName = () => {
    if (companyDetails.name) {
      return companyDetails.name;
    } else {
      return "Utilgjengelig";
    }
  };

  const renderMemberSince = () => {
    if (companyDetails.timestamp) {
      return `Medlem siden ${moment
        .unix(companyDetails.timestamp)
        .format("DD/MM/YYYY")}`;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderPriceDisplay = () => {
    if (subscription?.price && subscription?.quantity) {
      return (
        <div className="company-plan-container">
          <span className="price">
            <NumberFormat
              thousandSeparator={" "}
              displayType={"text"}
              value={(subscription?.price * subscription?.quantity) / 100}
            />
            kr
          </span>
          <span className="label">pr. måned</span>
          <p className="description">Standard abonnement</p>
        </div>
      );
    } else {
      return (
        <div className="company-plan-container">
          <p className="description">Ingen abonnement</p>
        </div>
      );
    }
  };

  const renderRemainingUsers = () => {
    if (subscription?.quantity && companyDetails.users) {
      if (companyDetails.users < subscription?.quantity) {
        return `${
          subscription?.quantity - companyDetails.users
        } brukere kan legges til før du må oppgradere.`;
      } else {
        return "Du må oppgradere for å legge til flere.";
      }
    } else {
      return "Kan ikke estimere grense for brukere igjen.";
    }
  };

  const renderPercentageBar = () => {
    if (subscription?.quantity && companyDetails.users) {
      return (companyDetails.users / subscription?.quantity) * 100;
    } else {
      return 0;
    }
  };

  const renderConditions = () => {
    if (subscription?.quantity && companyDetails.users) {
      return `${companyDetails.users}/${subscription?.quantity} brukt`;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const handleSelection = (dest) => {
    switch (dest) {
      case "team":
        setActiveDisplay(dest);
        window.history.pushState(null, null, `/dashboard/foretak#team`);
        break;
      case "channels":
        setActiveDisplay(dest);
        window.history.pushState(null, null, `/dashboard/foretak#kanaler`);
        break;
      case "invoices":
        setActiveDisplay(dest);
        window.history.pushState(null, null, `/dashboard/foretak#fakturaer`);
        break;
      case "subscriptions":
        setActiveDisplay(dest);
        window.history.pushState(null, null, `/dashboard/foretak#abonnementer`);
        break;
      case "paymentmethods":
        setActiveDisplay(dest);
        window.history.pushState(
          null,
          null,
          `/dashboard/foretak#betalingsmetoder`
        );
        break;
      case "settings":
        setActiveDisplay(dest);
        window.history.pushState(
          null,
          null,
          `/dashboard/foretak#innstillinger`
        );
        break;
      default:
        break;
    }
  };

  const tabSelections = [
    {
      id: 0,
      title: "Team",
      active: activeDisplay === "team" ? true : false,
      onClick: () => handleSelection("team"),
    },
    {
      id: 1,
      title: "Fakturaer",
      active: activeDisplay === "invoices" ? true : false,
      onClick: () => handleSelection("invoices"),
    },
    {
      id: 2,
      title: "Abonnementer",
      active: activeDisplay === "subscriptions" ? true : false,
      onClick: () => handleSelection("subscriptions"),
    },
    {
      id: 3,
      title: "Betalingsmetoder",
      active: activeDisplay === "paymentmethods" ? true : false,
      onClick: () => handleSelection("paymentmethods"),
    },
    {
      id: 4,
      title: "Innstillinger",
      active: activeDisplay === "settings" ? true : false,
      onClick: () => handleSelection("settings"),
    },
  ];

  const determineUpperView = () => {
    if (loading) {
      return (
        <div className="loading-overlay">
          <div className="inner-loading-overlay">
            <div className="loader-container">
              <div className="loader">
                <MoonLoader size={40} color={"#4CA1F1"} loading={true} />
              </div>
              <h3 className="loading-title">Henter bedriftsdetaljer..</h3>
              <Text align="center">Vennligst vent mens detaljene lastes</Text>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Row className="details-upper-row">
            <Col className="thumbnail-col text-left">
              <img
                alt="Mitt foretak"
                className="company-thumbnail"
                src={
                  !loading && companyDetails.thumbnail
                    ? companyDetails.thumbnail
                    : accountThumbnail
                }
              />
            </Col>
            <Col className="details-col text-left">
              {renderActiveBadge()}
              <h1 className="company-name">
                {renderCompanyName()}{" "}
                <i class="fas fa-badge-check verified"></i>
              </h1>
              <p className="company-type">{renderMemberSince()}</p>
              <>{renderPriceDisplay()}</>
            </Col>
            <Col className="buttons-col text-right">
              <div className="buttons-container">
                <SolidButton
                  onClick={() =>
                    dispatch(changeCompanyModal({ deleteSpace: true }))
                  }
                  color="gray"
                  title="Slett foretak"
                  icon={<i class="fas fa-trash-alt"></i>}
                />
              </div>
              <div className="statistics-container">
                <div className="percentage-container">
                  <div className="details-container">
                    <span className="details-title">Antall brukere</span>
                    <span className="details-count">{renderConditions()}</span>
                  </div>
                  <div className="progress-container">
                    <div className="progress" style={{ display: "flex" }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: renderPercentageBar() + "%" }}
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax={`100`}
                      />
                    </div>
                  </div>
                  <div className="description-container">
                    <p className="description">{renderRemainingUsers()}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="view-selection-container">
            {tabSelections.map((selection) => (
              <button
                onClick={selection.onClick}
                className={`tab-selection ${selection.active ? "active" : ""}`}
              >
                {selection.title}
              </button>
            ))}
          </div>
        </>
      );
    }
  };

  return (
    <section className="dashboard-company-upper-row-section">
      {determineUpperView()}
    </section>
  );
};

export default Index;
